<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">

        <div class="row align-items-end" *ngIf="loaded && !casoCerrado && !disableNoAdmin">
          <div class="col-md-12 mb-3">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="altaArbitroCheckbox" [(ngModel)]="altaArbitro"
                name="altaArbitro" (change)="toggleAltaArbitro()">
              <label class="form-check-label" for="altaArbitroCheckbox" i18n>
                No encuentro al representante en el listado, quiero darle de alta.
              </label>
            </div>
          </div>
        </div>

        <!-- Formulario de asignación de representante -->
        <div *ngIf="!altaArbitro">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !casoCerrado && !disableNoAdmin">
            <div class="row align-items-end">
              <div class="col-md-8 mb-3">
                <label for="selectUsuario" class="form-label" i18n>Representates (*)</label>
                <select2 [data]="usuarios" id="selectUsuario" name="id_usuario" #id_usuario="ngModel"
                  [(ngModel)]="model.id_usuario" multiple="false" displaySearchStatus="always" noLabelTemplate="true"
                  [ngClass]="{ 'is-invalid': (id_usuario.invalid && f.submitted) || (id_usuario.invalid && (id_usuario.dirty || id_usuario.touched))}">
                </select2>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-6 mb-3">
                <label for="inputDespachoAsignacion" class="form-label" i18n>Despacho</label>
                <input type="text" class="form-control" id="inputDespachoAsignacion" name="despacho_razon_social"
                  [(ngModel)]="model.despacho_razon_social">
              </div>

              <div class="col-md-6 mb-3">
                <label for="inputPartes" class="form-label custom-no-asterisk" i18n>Parte/s (*)</label>
                <select2 [data]="partesOptions" id="selectPartes" name="id_partes_seleccionadas" #id_partes_seleccionadas="ngModel"
                  [(ngModel)]="nuevoArbitro['id_partes_seleccionadas']" multiple="true" displaySearchStatus="always" noLabelTemplate="true"
                  [ngClass]="{ 'is-invalid': (id_partes_seleccionadas.invalid && f.submitted) || (id_partes_seleccionadas.invalid &&
                (id_partes_seleccionadas.dirty || id_partes_seleccionadas.touched))}" required [value]="partesDefaultSelected">
                </select2>                
              </div>

            </div>

            <div class="row align-items-end">
              <!-- Preguntas de control -->
              <div class="col-md-5 mb-2">
                <label class="form-label d-block" i18n>Enviar al representante email de asociación al caso (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionSi"
                    value="true" [(ngModel)]="model['enviar_email_asociacion']" required>
                  <label class="form-check-label" for="emailAsociacionSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionNo"
                    value="false" [(ngModel)]="model['enviar_email_asociacion']" required>
                  <label class="form-check-label" for="emailAsociacionNo" i18n>No</label>
                </div>
              </div>
              <div class="col-md-7 text-end mb-2">
                <button type="submit" class="btn btn-primary waves-effect waves-light"
                  [disabled]="f.invalid || !model.id_usuario || disableNoAdmin"><span i18n>Asociar al
                    caso</span></button>
              </div>
            </div>

          </form>
        </div>

        <!-- Formulario de alta de árbitro -->
        <div *ngIf="altaArbitro">
          <form #altaForm="ngForm" (ngSubmit)="onRegistrarArbitro(altaForm)" novalidate *ngIf="loaded && !disableNoAdmin">
            <div class="row align-items-end">
              <!-- Nombre -->
              <div class="col-md-4 mb-3">
                <label for="inputNombre" class="form-label" i18n>Nombre (*)</label>
                <input type="text" class="form-control" id="inputNombre" name="nombre"
                  [(ngModel)]="nuevoArbitro['nombre']" #nombre="ngModel" required
                  [ngClass]="{ 'is-invalid': (nombre.invalid && altaForm.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))}">
                <!--
                <div
                  *ngIf="(nombre.invalid && altaForm.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))">
                  <p class="validator-message" i18n>Campo obligatorio</p>
                </div>
                -->
              </div>

              <!-- Apellidos -->
              <div class="col-md-4 mb-3">
                <label for="inputApellidos" class="form-label" i18n>Apellidos (*)</label>
                <input type="text" class="form-control" id="inputApellidos" name="apellidos"
                  [(ngModel)]="nuevoArbitro['apellidos']" #apellidos="ngModel" required
                  [ngClass]="{ 'is-invalid': (apellidos.invalid && altaForm.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))}">
                <!--
                <div
                  *ngIf="(apellidos.invalid && altaForm.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))">
                  <p class="validator-message" i18n>Campo obligatorio</p>
                </div>
              -->
              </div>

              <!-- Correo electrónico -->
              <div class="col-md-4 mb-3">
                <label for="inputEmail" class="form-label"><span i18n>Correo electrónico (*)</span>
                  <span *ngIf="emailExiste" class="text-danger" i18n> El email ya existe</span>
                </label>
                <input type="email" class="form-control" id="inputEmail" name="email"
                  [(ngModel)]="nuevoArbitro['email']" #email="ngModel" required email
                  (blur)="onEmailBlur(nuevoArbitro['email'] ?? '')"
                  [ngClass]="{ 'is-invalid': (email.invalid && altaForm.submitted) || emailExiste || (email.invalid && (email.dirty || email.touched)) }">
                <!--
                <div *ngIf="(email.invalid && altaForm.submitted) || (email.invalid && (email.dirty || email.touched))">
                  <p class="validator-message" i18n>Introduzca una dirección de email válida</p>
                </div>
                -->
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-5 mb-3">
                <label for="inputDespachoAlta" class="form-label" i18n>Despacho</label>
                <input type="text" class="form-control" id="inputDespachoAlta" name="despacho_razon_social"
                  [(ngModel)]="nuevoArbitro['despacho_razon_social']">
              </div>

              <div class="col-md-2 mb-3"></div>

              <div class="col-md-5 mb-3">
                <label for="inputPartes" class="form-label custom-no-asterisk" i18n>Parte/s (*)</label>
                <select2 [data]="partesOptions" id="selectPartes" name="id_partes_seleccionadas" #id_partes_seleccionadas="ngModel"
                  [(ngModel)]="nuevoArbitro['id_partes_seleccionadas']" multiple="true" displaySearchStatus="always" noLabelTemplate="true"
                  [ngClass]="{ 'is-invalid': (id_partes_seleccionadas.invalid && altaForm.submitted) || (id_partes_seleccionadas.invalid &&
                (id_partes_seleccionadas.dirty || id_partes_seleccionadas.touched))}" required [value]="partesDefaultSelected">
                </select2>                
              </div>

            </div>

            <div class="row align-items-end">
              <!-- Preguntas de control -->
              <div class="col-md-5 mb-2">
                <label class="form-label d-block" i18n>Enviar al representante email de asociación al caso (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionSi"
                    value="true" [(ngModel)]="nuevoArbitro['enviar_email_asociacion']" required>
                  <label class="form-check-label" for="emailAsociacionSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionNo"
                    value="false" [(ngModel)]="nuevoArbitro['enviar_email_asociacion']" required>
                  <label class="form-check-label" for="emailAsociacionNo" i18n>No</label>
                </div>
              </div>

              <div class="col-md-4 mb-2">
                <label class="form-label d-block" i18n>Enviar al representante email de bienvenida (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_validacion" id="emailBienvenidaSi"
                    value="true" [(ngModel)]="nuevoArbitro['enviar_email_validacion']" required>
                  <label class="form-check-label" for="emailBienvenidaSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_validacion" id="emailBienvenidaNo"
                    value="false" [(ngModel)]="nuevoArbitro['enviar_email_validacion']" required>
                  <label class="form-check-label" for="emailBienvenidaNo" i18n>No</label>
                </div>
              </div>

              <div class="col-md-3 text-end mb-2 d-flex justify-content-end">
                <button type="submit" class="btn btn-primary waves-effect waves-light"
                  [disabled]="altaForm.invalid || emailExiste || validatingEmail"><span i18n>Registrar representante y
                    asociar al caso</span></button>
              </div>
            </div>
          </form>
        </div>


        <div class="position-relative mt-3"> <!-- Ajustado para reducir el margen superior -->
          <div id="status" class="spinner-container" *ngIf="isLoading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div class="row mt-4" *ngIf="representantesLoaded && representantesList.length > 0; else noInstituciones">
            <div class="col-md-4" *ngFor="let institucion of representantesList">
              <div class="card representante-card">
                <div class="card-body">
                  <div class="d-flex flex-row">
                    <img *ngIf="avatarUrls[institucion.id_usuario!]" [src]="avatarUrls[institucion.id_usuario!]"
                      class="rounded-circle" style="width: 65px; height: 65px; object-fit: cover;">
                    <div class="ms-3 flex-grow-1">
                      <h5>{{ institucion.nombre }} {{ institucion.apellidos }}</h5>
                      <p *ngIf="institucion['usuario'] && !institucion['usuario']['validado']" class="text-danger small">Usuario no validado</p>
                      <p>{{ institucion.tipo }}<br>
                        {{ institucion.despacho?.nombre }}</p>
                    </div>
                    <button type="button" class="btn btn-link position-absolute top-0 end-0"
                      (click)="openDeleteModal(institucion.id!)" [disabled]="disableNoAdmin">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switch_' + institucion.id" class="form-check-input me-2"
                      name="enviar_email_subida_archivo" [checked]="institucion.enviar_email_subida_archivo"
                      (change)="onSwitchChange(institucion.id)" [disabled]="disableNoAdmin">
                    <label for="'switch_' + institucion.id" class="form-check-label mt-0" i18n>Aviso de nuevos
                      documentos</label>
                  </div>
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switchHito_' + institucion.id" class="form-check-input me-2"
                      name="enviar_email_hito" [checked]="institucion['enviar_email_hito']"
                      (change)="onSwitchChangeHitos(institucion.id)" [disabled]="casoCerrado || disableNoAdmin">
                    <label for="'switch_' + institucion.id" class="form-check-label mt-0" i18n>Aviso de próximos
                      vencimientos</label>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <ng-template #noInstituciones>
            <p *ngIf="representantesLoaded" i18n>No se ha encontrado ningún representante</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar este representante?</span></p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
